import { ExpressionSpecification } from 'maplibre-gl'

export const createPaintExpression = (
  metricName: string,
  paintExpression: ExpressionSpecification,
): ExpressionSpecification => {
  return [
    'case',
    ['has', metricName],
    paintExpression,
    '#b3b3b3', // if state is missing gray!
  ]
}

export const getRoadCoverageMetricPaint = (metricName: string): ExpressionSpecification => {
  return [
    'interpolate',
    ['linear'],
    ['get', metricName],
    0,
    '#e9f8f9',
    5,
    '#cae4e7',
    7,
    '#a7ced3',
    10,
    '#87babf',
    20,
    '#62a6ac',
    100,
    '#3c909c',
  ]
}
